module.exports = __webpack_public_path__ + "static/media/noimage.a80f42e2.jpg";